import type { QueryParams } from "../../types";

export const landingPagesKeys = {
  all: ["landing-pages"] as const,
  list: (params: QueryParams) =>
    [...landingPagesKeys.all, "list", params] as const,
  detail: (id: number | string | undefined) =>
    [...landingPagesKeys.all, "detail", id] as const,
};
